<template>
    <form @submit.prevent="submit" ref="form" id="form-data">
        <slot></slot>
    </form>
</template>

<style lang="css" scoped></style>

<script setup lang="ts">
import axios, { type AxiosResponse } from "axios";
import { ref } from "vue";

interface Props {
    method: string;
    action: string;
    shouldSubmit?: () => boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    (event: "submit"): void;
    (event: "success", response: AxiosResponse): void;
    (event: "failure", error: unknown): void;
}>();
const form = ref<HTMLFormElement | null>(null);
const submitting = ref(false);

function submit(): void {
    if (submitting.value || (props.shouldSubmit && !props.shouldSubmit())) {
        return;
    }
    emit("submit");

    window.setTimeout(async () => {
        try {
            submitting.value = true;
            const response = await axios.request({
                method: props.method,
                url: props.action,
                data: new FormData(form.value as HTMLFormElement),
            });
            emit("success", response);
        } catch (error) {
            emit("failure", error);
            console.warn("Failed to submit form..", error);
        } finally {
            submitting.value = false;
        }
    }, 100);
}
</script>
